import React from 'react';
import { createEvent } from '../helpers';
import { GeckoBtn } from 'ui';
import './select_multi_buttons.scss';

const SelectMultiButtons = ({ value = [], onChange, name, options = [] }) => {
  const valueSet = new Set(value);

  const handler = (option) => {
    valueSet.has(option.value)
      ? valueSet.delete(option.value)
      : valueSet.add(option.value);
    onChange(createEvent({ name, value: [...valueSet] }));
  };

  const getClassname = (option) =>
    valueSet.has(option.value) ? 'selected' : 'unselected';

  return (
    <div className="SelectMultiButtons">
      {options.map((option) => (
        <GeckoBtn
          key={option.value}
          className={`SelectMultiButtons-component SelectMultiButtons-component-${getClassname(
            option
          )}`}
          name={option.label}
          handler={() => handler(option)}
        />
      ))}
    </div>
  );
};

export default SelectMultiButtons;
